<template>
  <div class="eva-student">
    <div class="week-group">
      <div class="week-con">
        <!--周次-->
        <i class="iconfont"  @click="changeDtList(true)">&#xe6a7;</i>
        <ul class="week-ul" v-if="weekList.length > 0">
          <li v-for="(item, indexs) in weekList[index]" :key="indexs" @click="dateSelect(item, indexs)">
            <span v-if="item.Week==='本周'" :data-date="item.Date" :class="item.IsCurrent ? 'is-cur-week':''">本周</span>
            <span v-else :data-date="item.Date" :class="item.IsCurrent ? 'is-cur-week':''">{{item.Week}}周</span>
          </li>
        </ul>
        <i class="iconfont" @click="changeDtList(false)">&#xe6a9;</i>
      </div>
      <!--本周-->
      <div class="current-week" v-if="currentWeek">
        <span>{{currentWeek.Date}}&nbsp;至&nbsp;{{currentWeek.endDate}}</span>
      </div>
    </div>
    <div class="class-list">
      <div class="schedule" ref="schedule" v-show="weekList.length > 0 && tableData.length>0">
        <div class="my-schedule-con">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th v-for="(week, index) in weekData" :key="index">
                  <span>{{week.weekName}}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(time,index) in tableTimes" :key="index">
                <td v-if="time.AMorPM==='NS'" colspan="8" style="border-right:none;background:#fff;height:60px;">{{time.AMorPMOrderName}}</td>
                <td v-else>{{time.AMorPMOrderName}}</td>
                <td v-for="(td, index) in 7" :key="index" v-show="time.AMorPM!=='NS'">
                  <div v-for="(data, index) in tableData" :key="index">
                    <div 
                      class="subject"
                      @click="goBatch(data,time.AMorPMOrderName)"
                      v-if="data.AMorPM === time.AMorPM && data.AMorPMOrder === time.AMorPMOrder && data.Day === td-1"
                      :class="data.IsAdjustment ? 'dis-td-bg': ''"
                      :style="{
                              'background': data.IsAdjustment ? '#ccc':xy.colors(data.CoursePlanAID).bg,
                              'color':xy.colors(data.CoursePlanAID).color,
                              'borderRadius':'0px 3px 3px 0px',
                              'borderLeft':'3px solid'+xy.colors(data.CoursePlanAID).color,
                              }"
                        >
                      <h5 :style="{'color':xy.colors(data.CoursePlanAID).color}">{{data.SubjectName}}</h5>
                      <p class="class-name" :title="data.CoursePlanTableFullName">{{data.CoursePlanTableFullName}}</p>
                      <p class="class-name" :title="data.TeacherInfos">{{data.TeacherInfos}}</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
       <div v-if="noData" class="xy-phone-no-data">
        <img src="@/assets/basic/moblie-no-data.png" />
        <p style="font-size:14Px;">暂无排课信息。</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
  export default {
    name: '',
    data () {
      return {
        noData:false,
        weekStart: '',
        weekEnd: '',
        tableTimes: [],
        tableData: [],
        weekList: [],
        yearID: 0,
        yearData: [],
        sessionID: 0,
        sessionData: [],
        weekData: [],
        currentWeek: null, // 高亮显示的数据
        index: 0 ,// 周数下标
        isComplete:false
      }
    },
    created () {
      if(this.$store.state.evaluation.isChangeClass){
        this.getIpad()
      }else{
         this.getYear()
      }
    },
    beforeDestroy() {
      this.$store.commit('evaluation/setChangeClass',true)
    },  
    mounted () {},
    methods : {
      async getIpad(){
         Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/Evaluation/GetClassTableByPad`)
         let datas = {
          isSettingGroupZu:res.data.IsSettingGroupZu, //是否有小组
          isSettingGroup: res.data.IsSettingGroup, // 方案下是是否完成
          CoursePlanAID: res.data.CoursePlanAID,  //
          CoursePlanAIDType: res.data.CoursePlanAIDType,
          StudentOrganizationID:res.data.StudentOrganizationID,
          DisciplineID: res.data.DisciplineID,
          SchoolDistrictID: res.data.SchoolDistrictID,  //校区id
          AcademicSessionID: res.data.AcademicSessionID, //
          ClassTableGenerateBaseID: res.data.ClassTableGenerateBaseID,
          StudentGradeForStudentYearID: res.data.StudentGradeForStudentYearID,
          AcademicYearID: res.data.AcademicYearID,
          DisciplineName:res.data.SubjectName  //学科名称
         }
         Toast.clear();
         if(res.success) {
            if(res.data.HasProgramme){
               datas.isEdit = true
                this.$store.commit('evaluation/changeIpadAverageObj',datas )
                this.$router.push({
                  path:'/ipad/evaStudent'
              })
            }else{
              this.getYear()
            }
          }
      },
      async goBatch (data, names) {
        // this.xy.loading()
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        // 根据科目ID获取方案是否设置小组评价
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/ProgrammeSetting/GetProgrammeByDisciplineID`, {
          disciplineID: data.DisciplineID,
          academicSessionID: data.AcademicSessionID,
          schoolDistrictID: data.SchoolDistrictID,
          studentGradeForStudentYearID: data.StudentGradeForStudentYearID
        })
        // this.xy.unloading()
        Toast.clear();
        if (res.success) {
          if (!res.data.HasProgramme) {
            // this.xy.msgError('该课程未设置评价方案。')
            Toast.fail({
                      message: '该课程未设置评价方案。',
                      className: 'ipad_toast',
                      forbidClick: true
                    })
          } else {
            this.isSettingGroup(data, names, res.data.HasGroup)
          }
        }
      },
      async isSettingGroup (data, names, setting) {
        // 判断分组完成
        if(setting){
          await  this.xyapi.get(`${this.$store.state.apiPath}/api/ClassRoomGroupRecord/GetMobileClassRoomRecordGroupInfo`,{
          schoolDistrictID:data.SchoolDistrictID,
          academicSessionID:data.AcademicSessionID,
          classTableGenerateBaseID:data.ClassTableGenerateBaseID,
          coursePlanAID:data.CoursePlanAID,
          coursePlanAIDType:data.CoursePlanAIDType.toString()
          }).then(res=>{
            if(res.success){
              this.isComplete = res.data.length===0?false:true
            }
          })
        }
        let tD = this.xy.moment(data.ClassDate).format('YYYY-MM-DD')
        let datas = {
          isSettingGroup: this.isComplete, //是否分组完成
          isSettingGroupZu: setting, //是否有小组
          CoursePlanAID: data.CoursePlanAID,  //
          CoursePlanAIDType: data.CoursePlanAIDType,
          StudentOrganizationID: data.StudentOrganizationID,
          DisciplineID: data.DisciplineID,
          SchoolDistrictID: data.SchoolDistrictID,  //校区id
          AcademicSessionID: data.AcademicSessionID, //
          ClassTableGenerateBaseID: data.ClassTableGenerateBaseID,
          StudentGradeForStudentYearID: data.StudentGradeForStudentYearID,
          AcademicYearID: data.AcademicYearID,
          DisciplineName:data.SubjectName  //学科名称
        }
     
        if ((this.xy.moment(tD).diff(this.xy.moment(this.weekEnd), 'days') <= 0 && this.xy.moment(tD).diff(this.xy.moment(this.weekEnd), 'days') >= -6)) { // （本周）可编辑
          datas.isEdit = true
          console.log('可编辑',datas);
          this.$store.commit('evaluation/changeIpadAverageObj', datas)
          this.$router.push({
            path:'/ipad/evaStudent'
          })
        } else { // 不可编辑
          datas.isEdit = false
          console.log('不可编辑',datas);
          this.$store.commit('evaluation/changeIpadAverageObj', datas)
          this.$router.push({
            path:'/ipad/evaStudent'
          })
        }
      },
      // 获取学年
      async getYear () {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/YearList`)
        // this.xy.unloading()
        Toast.clear();
        if (res.success) {
          this.yearData = res.data
          if (res.data.length > 0) {
            let arr = res.data.filter(function (item) { return item.IsCurrent === true })
            if (arr.length > 0) {
              this.yearID = arr[arr.length - 1].ID
            } else {
              if (res.data.length > 0) {
                this.yearID = res.data[0].ID
              }
            }
          }
          this.getSession(this.yearID)
        }
      },
      // 获取学期
      async getSession (id) {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SessionList`, { yearID: id })
        Toast.clear();
        if (res.success) {
          this.sessionData = []
          this.sessionID = 0
          if (res.data.length > 0) {
            this.sessionData = res.data
            let arr = res.data.filter(function (item) { return item.IsCurrent === true })
            if (arr.length > 0) {
              this.sessionID = arr[arr.length - 1].AcademicSessionID
            } else {
              if (res.data.length > 0) {
                this.sessionID = res.data[0].AcademicSessionID
              }
            }
          }
          this.getWeek(this.sessionID)
        }
      },
      // 获取周次信息
      async getWeek () {
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/Evaluation/GetWeek`, null, true)
        if (res.success) {
          let resDataListWeek = this.group(res.data, 5)
          if (resDataListWeek.length > 0) {
            for (let i in resDataListWeek) {
              for (let val of resDataListWeek[i]) {
                if (val.Week === '本周') {
                  this.index = Number(i)
                  this.weekStart = val.Date
                  this.weekEnd = this.xy.moment(val.Date, 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD')
                  this.currentWeek = {
                    Week: val.Week,
                    Date: val.Date,
                    WeekInfo: val.WeekInfo,
                    IsCurrent: true,
                    // 周日日期
                    endDate: this.xy.moment(val.Date, 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD')
                  }
                }
                val.IsCurrent = val.Week === '本周'
              }
            }
            this.weekList = resDataListWeek
          }

          // 如果获取来的数据没有“本周”，将把数组第一周置为开始
          if (!this.currentWeek && this.weekList.length) {
            this.weekList[0].IsCurrent = true
          }
          this.weekData = []
          for (let i = 0; i < 7; i++) {
            this.weekData.push({
              weekName: this.xy.getChinesesWeekForNumSmall(i)
            })
          }
          if ((this.currentWeek && this.currentWeek.Date) || this.weekList.length) {
            this.getWeekTimeTable(this.currentWeek.Date || this.weekList[0].Date)
          }
        }
      },
      // 把一个数组按照一定长度分割成若干数组
      group (array, subGroupLength) {
        let index = 0
        let newArray = []
        while (index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength))
        }
        return newArray
      },
      // 获取周课表
      async getWeekTimeTable (startDate) {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetClassTable`, { start: startDate })
        Toast.clear();
        if (res.success) {
          this.tableData = res.data
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].StartTime) {
                this.tableData[i].StartTime = this.tableData[i].StartTime.substr(0, 5)
              }
              if (this.tableData[i].EndTime) {
                this.tableData[i].EndTime = this.tableData[i].EndTime.substr(0, 5)
              }
            }
          }else{
            this.noData=true
          }
          this.getTimes(startDate)
        }
      },
      async getTimes (startDate) {
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/Evaluation/GetTableTimes`, {
          start: startDate
        })
        if (res.data) {
          this.tableTimes = res.data
          // this.checkTime()
        }
      },
      checkTime(){
        console.log("????")
        let week = this.xy.moment().format('E')
        console.log(week)
        let time = this.xy.moment().format('10:00', 'HH:mm')
        let arr = []
        this.tableData.map(item => {
          if (item.Day === week - 1) {
            console.log(item.Day)
            arr.push(item)
          }
        })
        console.log(arr)

        if (arr.length > 0) {
          var value = arr.find(item => {
            return this.timeFormat(time) >= this.timeFormat(item.StartTime) && this.timeFormat(time) <= this.timeFormat(item.EndTime)
          }
          )
          console.log(arr)
          if (value !== undefined) {
            this.goBatch(value, '', true)
          }
        }
      },
    timeFormat  (date, format) { // time时间格式化
      if (date === null || date === '') return ''

      if (typeof date === 'string') { // 如果是字符串转换为日期型
        date = new Date('2008-01-01 ' + date)
      }

      if (!format) {
        format = 'yyyy-MM-dd HH:mm:ss'
      }
      var obj =
        {
          'M+': date.getMonth() + 1, // 返回实际月份
          'd+': date.getDate(), // 返回当月第几天
          'H+': date.getHours(), // 返回小时
          'm+': date.getMinutes(), // 返回分钟
          's+': date.getSeconds(), // 返回秒
          'q+': Math.floor((date.getMonth() + 3) / 3), // 返回第几个季度
          'S': date.getMilliseconds(), // 返回毫秒
          'w': date.getDay(), // 返回星期几，0为星期日
          'W': '日一二三四五六'.charAt(date.getDay()) // 返回星期几的中文表示
        }

      // 年的单独处理
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      // 其他格式处理
      for (var k in obj) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? obj[k] : ('00' + obj[k]).substr(('' + obj[k]).length))
        }
      }
      return format
},
      // 分页 status === true 向前，！status向后
      changeDtList (status) {
        if (status) {
          if (this.index - 1 >= 0) {
            this.index -= 1
          } else {
            // return this.xy.msgError('已经是第一页了。')
            return  Toast.fail({
                      message: '已经是第一页了。',
                      className: 'ipad_toast',
                      forbidClick: true
                    })
          }
        } else {
          if (this.index + 1 <= this.weekList.length - 1) {
            this.index += 1
          } else {
            // return this.xy.msgError('已经是最后页了。')
             return Toast.fail({
                      message: '已经是最后页了。',
                      className: 'ipad_toast',
                      forbidClick: true
                    })
          }
        }
      },
      // 点击周次
      dateSelect (val) {
        if (val.Date === this.currentWeek.Date) { return }
        for (const i in this.weekList) {
          for (const v of this.weekList[i]) {
            if (v.Date === val.Date) {
              v.IsCurrent = true
              this.currentWeek = {
                Week: v.Week,
                Date: v.Date,
                WeekInfo: v.WeekInfo,
                IsCurrent: true,
                // 周日日期
                endDate: this.xy.moment(v.Date, 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD')
              }
            } else {
              v.IsCurrent = false
            }
          }
        }
        this.getWeekTimeTable(val.Date)
      }
    }
  }
</script>
<style lang='less' scoped>
.xy-phone-no-data {
  width: 100%;
  height: 50%;
  overflow: hidden;
  margin: 20% auto 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
}
.class-list{
  padding:10px;
  padding-top:0;
  background: #fff;
}
td,th{
  font-size: 12Px;
}
.schedule .table {
  text-align: center;
  margin: 0 auto;
  border-collapse: collapse;
  font-size: 14Px;
  width: 100%;
}
.schedule .my-schedule-head {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 5;
  width: 100%;
  height: 50px;
}
.schedule .table thead th:first-child{
  width: 58px;
}
.schedule .table thead th:not(:first-child){
  border-right: 1px solid #E5E5E5;
  width: calc((100vw - 58px) / 7);
}
.schedule .table thead th {
  width: 12.5%;
  height: 50px;
  background:#F9F8F9;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-weight: 400;
  color:#292529;
  font-size: 17Px;
}
.schedule .table tbody td {
  height: 80px;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #eceef1;
  border-right: 1px solid #fff;
  position: relative;
  padding: 1px;
  color: #292529;
  font-size: 16Px;
}
.schedule table tbody tr td:not(:first-child) {
  border-right: 1px solid #E5E5E5;
}
.schedule table tbody tr td:first-child  {
  background: #F9F8F9;
}
.subject {
  padding: 6px 0 6px 10px;
  margin: 1px auto;
  background: #f5f5f5;
  border-radius: 5px;
  text-align: left;
  min-height: 80px;
  cursor: pointer;
}
.subject > h5 {
  font-weight: bold;
}
.subject > p {
  font-weight: normal;
  font-size: 14Px;
}
.filter-state {
  width: 100%;
  height: 28px;
  line-height: 28px;
  background-color: rgba(149, 181, 255, 0.24) !important;
  text-align: center;
  margin: 17px 0 22px;
  font-size: 12Px;
  color: #666;
  border-radius: 5px;
  overflow: hidden;
  cursor: default;
  border: none;
}

.dis-td-bg {
  background: rgb(198, 198, 198) !important;
  border-left-color: rgb(135, 135, 135) !important;
  color: rgb(135, 135, 135) !important;
}
/* 暂无数据样式 */
.no-data-box {
  width: 392px;
  margin: 50px auto;
  position: relative;
}
.no-data-box > .no-data-img {
  width: 250px;
}
.no-data-box > .no-data-text {
  position: absolute;
  top: 160px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 18Px;
  display: inline-table;
}
.week-group{
  background: #fff;
}
.week-con {
  height:40px;
  line-height: 40px;
  background: #fff;
  width: 600px;
  margin: 0 auto;
  // padding-top: 10px;
  text-align: center;
}
.week-con .iconfont {
  font-size:14Px;
  cursor: pointer;
  color: #eeeeee;
  margin: 0 20px;
  padding: 0 10px;
  display: inline-block;
  vertical-align: middle;
  transition: all 0.3s;
}
.week-con .iconfont:hover {
  transition: all 0.3s;
  cursor: pointer;
  color: #1677ff;
  opacity: 0.7;
}
.week-ul {
  width: 430px;
  display: inline-block;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: bottom;
  // vertical-align: middle;
}
.week-ul li {
  display: inline-block;
}
.week-ul li span {
  font-weight: 500;
  font-size: 17Px;
  color: rgba(0, 0, 0, 0.85);
  padding: 2px 20px;
  cursor: pointer;
  margin: 0 4px;
}
.week-ul li span:hover {
  background: #0877FF;
  border-radius: 4px;
  color: #fff;
}
.is-cur-week {
  background: #0877FF;
  color: #fff !important;
  border-radius: 4px;
}
.current-week {
  padding: 2px 0 10px 0;
  color: #adadad;
  font-size: 12Px;
  text-align: center;
}
.current-week .week-num {
  font-size: 16Px;
  font-weight: bold;
  margin-right: 5px;
}
</style>
